export default "__VITE_ASSET__DoK_ze2t__"